module.exports = __webpack_public_path__ + "img/2-4.e382d466.jpg";